import { useEffect } from 'react'

const TAWK_SRC = 'https://embed.tawk.to/6638189b07f59932ab3c5612/1ht5i082t'

declare global {
  interface Window {
    Tawk_API?: Record<string, unknown>
    Tawk_LoadStart?: Date
  }
}

/** Inyecta el widget de chat de Tawk.to una sola vez. */
export function useTawkTo(): void {
  useEffect(() => {
    if (document.querySelector(`script[src="${TAWK_SRC}"]`)) return

    window.Tawk_API = window.Tawk_API || {}
    window.Tawk_LoadStart = new Date()

    // Posiciona la burbuja de chat en la esquina inferior izquierda.
    window.Tawk_API.customStyle = {
      visibility: {
        desktop: {
          position: 'bl',
          xOffset: 24,
          yOffset: 24,
        },
        mobile: {
          position: 'bl',
          xOffset: 12,
          yOffset: 12,
        },
      },
    }

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.src = TAWK_SRC
    script.charset = 'UTF-8'
    script.setAttribute('crossorigin', '*')

    const firstScript = document.getElementsByTagName('script')[0]
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript)
    } else {
      document.body.appendChild(script)
    }
  }, [])
}
